export enum ValidationState {
    Invalid = 0,
    Valid = 1,
    Validating = 2,
}

export enum ProcessingState {
    Failed = 0,
    NotStarted = 1,
    Done = 2,
    Processing = 3, 
}